<template>
  <div>
    <BaseModalHeader>
      <BaseHeading :semantic-level="2" :display-level="1">
        {{ getTitle }}
      </BaseHeading>
    </BaseModalHeader>
    <div :class="$style.technicianPictureWrapper">
      <img
        :src="technician.picture"
        :alt="technician.lastName"
        crossorigin="use-credentials"
        :class="$style.technicianPictureBlur"
      >
      <img
        :src="technician.picture"
        :alt="technician.lastName"
        crossorigin="use-credentials"
        :class="$style.technicianPicture"
      >
    </div>
    <BaseModalContent>
      <TextContainer align="center">
        <BaseText type="bold">
          {{ technician.firstName }}
        </BaseText>
        <BaseText v-if="technician.slogan" :class="$style.sloganCaption">
          Mein Motto
        </BaseText>
        <BaseText v-if="technician.slogan" :class="$style.slogan">
          "{{ technician.slogan }}"
        </BaseText>
      </TextContainer>
    </BaseModalContent>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useAppointmentStore } from '~/terminierungsportal/stores/appointment'
import BaseModalHeader from '~/base/components/modal/ModalHeader.vue'
import BaseHeading from '~/base/components/heading/Heading.vue'
import BaseModalContent from '~/base/components/modal/ModalContent.vue'
import BaseText from '~/base/components/text/Text.vue'
import TextContainer from '~/base/components/textContainer/TextContainer.vue'
import type { Technician } from '~/base/types/technician/technician'
import { PrefixType, getGenderedTechnician } from '~/base/utils/gender'

const appointmentStore = useAppointmentStore()

const technician = computed((): Technician => {
  return appointmentStore.appointment.technician
})

const getTitle = computed((): string => {
  return getGenderedTechnician(technician.value, PrefixType.YOUR)
})
</script>

<style module>
.technicianPictureBlur {
  z-index: 1;
  position: absolute;
  object-fit: cover;
  object-position: center;
  filter: blur(25px);
  aspect-ratio: 16/9;

  @media screen and (min-width: 320px) {
    min-height: 225px;
    min-width: 350px;
  }

  @media screen and (min-width: 740px) {
    min-height: 281px;
    min-width: 500px;
  }
}

.technicianPictureWrapper {
  position: relative;
  overflow: hidden;
  margin-left: -22px;
  margin-right: -22px;
}

.technicianPicture {
  z-index: 2;
  position: relative;
  width: 100%;
  object-fit: contain;
  object-position: center top;

  @media screen and (min-width: 320px) {
    min-height: 225px;
    min-width: 350px;
  }

  @media screen and (min-width: 740px) {
    min-height: 281px;
    min-width: 500px;
    aspect-ratio: 16/9;
    background-size: contain;
  }
}

.sloganCaption {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-turquoise);
  margin-top: var(--space-sm);
}

.slogan {
    margin-top: 0;
}
</style>
